var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgToaterSuccess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1892_15195)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.0532 3.14457C11.5759 2.48633 9.92535 2.32326 8.34779 2.67968C6.77024 3.03611 5.35017 3.89294 4.29936 5.12238C3.24856 6.35182 2.62332 7.888 2.51691 9.50181C2.4105 11.1156 2.8286 12.7206 3.70887 14.0774C4.58914 15.4341 5.88441 16.47 7.4015 17.0305C8.9186 17.591 10.5762 17.6461 12.1272 17.1875C13.6781 16.7289 15.0393 15.7813 16.0077 14.4859C16.976 13.1906 17.4997 11.6169 17.5007 9.99957V9.23338C17.5007 8.77315 17.8738 8.40005 18.334 8.40005C18.7942 8.40005 19.1673 8.77315 19.1673 9.23338V10.0001C19.1662 11.9768 18.5261 13.9006 17.3425 15.4839C16.159 17.0671 14.4953 18.2253 12.5997 18.7858C10.7041 19.3462 8.67814 19.2789 6.82392 18.5939C4.96969 17.9089 3.38658 16.6428 2.3107 14.9845C1.23481 13.3262 0.723793 11.3646 0.853855 9.39215C0.983917 7.41971 1.74809 5.54216 3.03241 4.03951C4.31672 2.53686 6.05237 1.48963 7.98049 1.05399C9.90861 0.618361 11.9259 0.817669 13.7315 1.62219C14.1519 1.80951 14.3408 2.30216 14.1535 2.72255C13.9662 3.14294 13.4735 3.33189 13.0532 3.14457Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.9216 2.74378C19.2472 3.06906 19.2475 3.59669 18.9222 3.92229L10.5889 12.264C10.4326 12.4204 10.2206 12.5083 9.99956 12.5083C9.77847 12.5084 9.56642 12.4206 9.41009 12.2643L6.91009 9.76426C6.58466 9.43882 6.58466 8.91118 6.91009 8.58574C7.23553 8.26031 7.76317 8.26031 8.0886 8.58574L9.99905 10.4962L17.7431 2.74437C18.0684 2.41877 18.596 2.41851 18.9216 2.74378Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1892_15195"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgToaterSuccess);
export default __webpack_public_path__ + "static/media/toater-success.b698657956d6712df0f8692ddc18189c.svg";
export { ForwardRef as ReactComponent };